import axios from "axios";
// const endPointUrl = "http://localhost:3211/api";
const endPointUrl = "https://dev.muekarator.com/api";

// Base configuration for all API requests
export const apiClient = axios.create({
  baseURL: endPointUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add an interceptor for adding the token if available
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Request OTP endpoint
export const receiveOTP = async (email) => {
  try {
    const payload = { email };
    const response = await apiClient.post("/devroute/auth/send-otp", payload);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Verify OTP endpoint
export const verifyOTP = async (email, otp) => {
  try {
    const response = await apiClient.post("/devroute/auth/verify-otp", {
      email,
      otp,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Set password endpoint
export const setPassword = async (email, password, referralCode) => {
  try {
    const payload = { email, password };
    if (referralCode) {
      payload.referralCode = referralCode;
    }
    const response = await apiClient.post(
      "/devroute/auth/set-password",
      payload
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Login endpoint
export const loginUser = async (email, password) => {
  try {
    const payload = { email, password };
    const response = await apiClient.post("/devroute/auth/login", payload);
    return response.data;
  } catch (error) {
    console.log("Response data:", error);
    throw error;
  }
};

// Login endpoint
export const forgotPassword = async (email) => {
  try {
    const payload = { email };
    const response = await apiClient.post("/devroute/auth/request-password-reset", payload);
    return response.data;
  } catch (error) {
    console.log("Response data:", error);
    throw error;
  }
};

export const resetPassword = async (token, newPassword) => {
  try {
    const payload = { token, newPassword };
    const response = await apiClient.post("/devroute/auth/reset-password", payload);
    return response.data;
  } catch (error) {
    console.log("Response data:", error);
    throw error;
  }
};

export const fetchUserInfo = async () => {
  try {
    const res = await apiClient.get('/devroute/auth/me');
  return res.data;
  } catch (error) {
    console.log("Failed to fetch user info:", error.response?.data || error.message);
    throw error;
  }
};

// Post Hero section data
export const postHeroData = async (formData) => {
  try {
    // const payload = { formData };
    const response = await apiClient.post("/devroute/hero-section", formData);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getHeroData = async () => {
  try {
    const response = await apiClient.get("/devroute/hero-section");
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const generateContent = async (promt) => {
  try {
    const response = await apiClient.post("/devroute/generate", promt);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Post Services section data
export const postServicesData = async (formData) => {
  try {
    // const payload = { formData };
    const response = await apiClient.post("/devroute/services-section", formData);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getServicesData = async () => {
  try {
    const response = await apiClient.get("/devroute/services-section");
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const postPortfolioData = async (formData) => {
  try {
    // const payload = { formData };
    const response = await apiClient.post("/devroute/portfolio-section", formData);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const getPortfolioData = async () => {
  try {
    const response = await apiClient.get("/devroute/portfolio-section");
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const postTestimonialData = async (formData) => {
  try {
    const response = await apiClient.post("/devroute/testimonials-section", formData);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getTestimonialData = async () => {
  try {
    const response = await apiClient.get("/devroute/testimonials-section");
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const postContactData = async (formData) => {
  try {
    const response = await apiClient.post("/devroute/contact-section", formData);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getContactData = async () => {
  try {
    const response = await apiClient.get("/devroute/contact-section");
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const postOfferPageData = async (formData) => {
  try {
    const response = await apiClient.post("/devroute/offer-page", formData);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getOfferPageData = async () => {
  try {
    const response = await apiClient.get("/devroute/offer-page");
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getContacts = async (query) => {
try {
    const response = await apiClient.get("/devroute/contact", query);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// ✅ Get all media
export const getAllMedia = async () => {
  try {
    const response = await apiClient.get("/devroute/media/all");
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// ✅ Upload media (supports multiple files + category)
export const uploadMedia = async (formData) => {
  try {
    const response = await apiClient.post("/devroute/media/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// ✅ Delete a specific media by ID
export const deleteMedia = async (mediaId) => {
  try {
    const response = await apiClient.delete(`/devroute/media/${mediaId}`);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// ✅ Get media by category
export const getMediaByCategory = async (category) => {
  try {
    const response = await apiClient.get(`/devroute/media/category/${category}`);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};